import { Link } from 'react-router-dom';
import { useState } from 'react';
import { hotRecommendations } from '@/mocks/homeData';
import { categories } from '@/mocks/homeData';

export default function HotRecommend() {
  const [activeTab, setActiveTab] = useState<string>('all');

  const filtered = activeTab === 'all'
    ? hotRecommendations
    : hotRecommendations.filter((item) => item.category === activeTab);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选高分日本影视，口碑佳作不容错过
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-8 flex-wrap">
          <button
            onClick={() => setActiveTab('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
              activeTab === 'all'
                ? 'bg-primary-500 text-white'
                : 'bg-background-50 text-foreground-600 hover:bg-background-200'
            }`}
          >
            全部推荐
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((item) => (
            <Link
              key={item.id}
              to={`/category/${item.category}`}
              className="group bg-white rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
            >
              <div className="aspect-[2/3] overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={`${item.title} - 日本在线观看`}
                />
                <div className="absolute top-2 left-2 flex items-center gap-1.5">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                    {item.categoryName}
                  </span>
                  {item.featured && (
                    <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                      推荐
                    </span>
                  )}
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/70 text-white px-1.5 py-0.5 rounded-md">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  <span className="text-xs font-medium">{item.rating}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-serif font-semibold text-foreground-900 text-sm md:text-base mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                  {item.description}
                </p>
                <span className="text-xs text-foreground-400">{item.year}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}